export default __webpack_public_path__ + "22fe75d042cec1da7a6ce5a59bbd13e5.png";